import React, { useState } from "react";

import PropTypes from "prop-types";

import { AutoComplete } from "primereact/autocomplete";

import LISTA_CARGOS from "./cargos";

export default function CargoAutocomplete({
  value,
  onChange,
  placeholder = "Selecione um cargo",
  id = "cargo",
  className = ""
}) {
  const [suggestions, setSuggestions] = useState([]);

  const search = (e) => {
    const query = e.query.toLowerCase();
    const filtrados = LISTA_CARGOS.filter((c) =>
      c.toLowerCase().includes(query)
    );
    setSuggestions(filtrados);
  };

  return (
    <AutoComplete
      id={id}
      className={`w-100 ${className}`}
      inputClassName="form-control" // aplica a mesma classe do Bootstrap no input interno
      value={value}
      suggestions={suggestions}
      completeMethod={search}
      onChange={(e) => onChange(e.value)}
      dropdown
      placeholder={placeholder}
    />
  );
}

CargoAutocomplete.defaultProps = {
  value: "",
  placeholder: "Selecione um cargo",
  id: "cargo",
  className: ""
};
